<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-11-24 16:45:54
-->
<template>
  <el-dialog
    :class="['ve--dialogEx', isFullWindow ? 'full-window' : null]"
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="isVisible"
  >
    <template slot="title" v-if="false || !!$slots.header">
      <slot name="header"></slot>
    </template>
    <template v-else slot="title">
      <span class="el-dialog__title">{{ title || "-" }}</span>
      <button
        type="button"
        :title="isFullWindow ? '还原' : '最大化'"
        aria-label="min-max"
        class="el-dialog__headerbtn btn__min-or-max"
        @click="isFullWindow = !isFullWindow"
      >
        <fa-icon
          class="font-14"
          :icon="
            isFullWindow
              ? ['far', 'window-restore']
              : ['far', 'window-maximize']
          "
        ></fa-icon>
      </button>
    </template>
    <slot></slot>
    <template slot="footer">
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    visible: Boolean,
    windowState: String,
  },
  data() {
    return {
      isFullWindow: this.windowState == "maximum" ? true : false,
    };
  },
  watch: {
    isFullWindow(newValue, oldValue) {
      this.$emit("windowStateChanged");
      this.$emit(
        "update:windowState",
        this.isFullWindow ? "maximum" : "normal"
      );
    },
    windowState(newValue) {
      this.isFullWindow = newValue == "maximum" ? true : false;
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
};
</script>

<style lang="scss">
.ve--dialogEx {
  .btn__min-or-max {
    right: 45px;
    color: #909399;
    line-height: 16px;
    top: 16px;
  }

  &.full-window .el-dialog {
    border-radius: 2px;
    width: calc(100% - 8px) !important;
    min-width: calc(100% - 8px) !important;
    height: calc(100% - 8px) !important;
    min-height: calc(100% - 8px) !important;
    margin: 4px !important;
    padding: 4px !important;
  }
}
</style>